var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-input',_vm._b({attrs:{"rules":_vm.rules}},'v-input',_vm.$attrs,false),[_c('vue-signature-pad',{ref:"signature",staticStyle:{"-webkit-touch-callout":"none","-webkit-user-select":"none","-khtml-user-select":"none","-moz-user-select":"none","-ms-user-select":"none","user-select":"none"},attrs:{"width":_vm.width,"height":_vm.height,"options":{
			backgroundColor: this.backgroundColor,
			onEnd: _vm.onSignatureEnd
		}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }